<script>
import ModalCourseSubjectActivityComponent from '../../features/modals/ModalCourseSubjectActivityComponent';
export default {
  name: 'ModalCourseSubjectActivityView',
  extends: ModalCourseSubjectActivityComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Actividad"
    width="42%"
    class="course-subject-activity-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Actividad</legend>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
            :xl="14"
          >
            <el-form-item
              label="Título"
              prop="title"
            >
              <el-input
                v-model="formData.title"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="4"
            :lg="4"
            :xl="4"
            align="center"
          >
            <el-form-item
              label="Orden"
              prop="sort"
            >
              <el-input-number
                v-model="formData.sort"
                size="small"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="5"
            :lg="5"
            :xl="5"
            align="center"
          >
            <el-form-item
              label="Duración (Min.)"
              prop="duration"
            >
              <el-input-number
                v-model.number="formData.duration"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="5"
            :xl="5"
            align="center"
          >
            <el-form-item label="¿Tiene Archivo?">
              <el-switch
                v-model="formData.hasFile"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="5"
            :xl="5"
            align="center"
          >
            <el-form-item label="¿Tiene Video?">
              <el-switch
                v-model="formData.hasVideo"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="5"
            :xl="5"
            align="center"
          >
            <el-form-item label="¿Respuesta Abierta?">
              <el-switch
                v-model="formData.hasOpenResponse"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
            align="center"
          >
            <el-form-item label="¿Respuesta Multiple?">
              <el-switch
                v-model="formData.hasMultipleResponse"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
                @change="onChangeMultipleResponse"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
            align="center"
          >
            <el-form-item label="¿Es Público?">
              <el-switch
                v-model="formData.isPublic"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Descripción"
              prop="description"
            >
              <el-input
                v-model="formData.description"
                :row="3"
                size="small"
                class="description-editor"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasFile"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <legend>Información de Archivo</legend>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasFile"
          v-loading="isFileLoading"
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="14"
            :md="14"
            :lg="14"
            :xl="14"
            align="center"
          >
            <el-form-item prop="coverImage">
              <div
                v-if="!formData.file && !formData.fileUrl"
                style="padding-top:30px;"
              >
                <el-upload
                  class="file-uploader"
                  :name="'coverImageFileUploader'"
                  action
                  :on-success="onSuccessUploadActivityFile"
                  :before-upload="onBeforeUploadActivityFile"
                  :show-file-list="false"
                  :data="formData.file"
                >
                  <el-button
                    size="small"
                    type="primary"
                    class="btn-primary"
                  >
                    <i class="el-icon-upload" /> Click para subir archivo
                  </el-button>
                </el-upload>
              </div>
              <div
                v-if="isActivityFileTemp"
                style="padding-top:30px;"
              >
                <el-button-group>
                  <el-button
                    size="small"
                    type="primary"
                    class="btn-primary"
                  
                    @click="onShowActivityFile(formData)"
                  >
                    <i class="el-icon-view" /> Ver Archivo
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    class="btn-delete"
                    @click="onRemoveActivityFile"
                  >
                    <i class="el-icon-circle-close" /> Eliminar Archivo
                  </el-button>
                </el-button-group>
              </div>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="10"
            :md="10"
            :lg="10"
            :xl="10"
            align="center"
          >
            <el-form-item label="¿Es Descargable?">
              <el-switch
                v-model="formData.isDownload"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasVideo"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <legend>Información de Video</legend>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasVideo"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Enlace Video"
              prop="videoUrl"
            >
              <el-input
                v-model="formData.videoUrl"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasMultipleResponse"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <legend>Información de Respuestas</legend>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.hasMultipleResponse"
          type="flex"
          class="row-bg"
          :gutter="20"
          style="padding-top:10px;"
        >
          <el-col :span="24">
            <el-button
              type="primary"
              size="small"
              class="btn-primary"
              icon="el-icon-circle-plus"
              @click="onCreateCourseSubjectActivityAnswer"
            >
              Agregar Respuesta
            </el-button>
          </el-col>
        </el-row>
        <br>
        <el-row
          v-if="formData.hasMultipleResponse"
          v-loading="isAnswerLoading"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-table
              :data="formData.getCourseSubjectActivityAnswers()"
              empty-text="No se encontraron resultados."
            >
              <el-table-column
                label="RESPUESTA"
                min-width="300"
              >
                <template #default="scope">
                  <div>
                    <el-input
                      v-model="scope.row.title"
                      size="small"
                      :class="'answer_editor_' + scope.$index + ' course_activity_answer'"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="CORRECTO"
                min-width="120"
                align="center"
              >
                <template #default="scope">
                  <div>
                    <el-switch
                      v-model="scope.row.success"
                      active-color="#13ce66"
                      active-text="SI"
                      inactive-text="NO"
                      size="small"
                    />
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="OPCIONES"
                :width="90"
                align="center"
                text-align="center"
              >
                <template #default="scope">
                  <el-button-group>
                    <el-button
                      type="info"
                      size="small"
                      icon="el-icon-delete"
                      @click="
                        onDeleteCourseSubjectActivityAnswer(scope.$index)
                      "
                    />
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Aceptar</el-button>
      </span>
    </template>
  </el-dialog>
</template>
